interface Format {
  value: string;
  label: string;
}

// export const baseUrl = "https://ozivoky7fsml.marvintest.vito.be/geoserver";
export const baseUrl = "/geoserver";
const bbox = [
  277356.3478783069, 6561945.175984552, 687273.0831585599, 6732213.385126582,
];
const width = 768;
const height = 330;
const srs = "EPSG:3857";

export const wfsOptionsUrl = `${baseUrl}/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=insertLayerHere&maxFeatures=50&outputFormat=`;
export const baseOptionsUrl = `${baseUrl}/wms?service=WMS&version=1.1.0&request=GetMap&layers=insertLayerHere&bbox=${bbox}&width=${width}&height=${height}&srs=${srs}&styles=&format=`;
export const extraWFSFormats: Format[] = [
  {
    value: "csv",
    label: "CSV",
  },
  {
    value: "text/xml; subtype=gml/2.1.2 ",
    label: "GML2",
  },
  {
    value: "gml3",
    label: "GML3.1",
  },
  {
    value: "application/gml%2Bxml; version=3.2",
    label: "GML3.2",
  },
  {
    value: "application/json",
    label: "GeoJSON",
  },
  {
    value: "application/vnd.google-earth.kml+xml",
    label: "KML",
  },
  {
    value: "SHAPE-ZIP",
    label: "Shapefile",
  },
  {
    value: "text/csv",
    label: "Text/csv",
  },
];

export const baseFormats: Format[] = [
  {
    value: "application/atom+xml",
    label: "AtomPub",
  },
  {
    value: "image/gif",
    label: "GIF",
  },
  {
    value: "rss",
    label: "GeoRSS",
  },
  {
    value: "image/jpeg",
    label: "JPEG",
  },
  {
    value: "image/geotiff",
    label: "GeoTIFF",
  },
  {
    value: "image/geotiff8",
    label: "GeoTIFF 8-bits",
  },
  {
    value: "image/vnd.jpeg-png",
    label: "JPEG-PNG",
  },
  {
    value: "image/vnd.jpeg-png8",
    label: "JPEG-PNG 8-bits",
  },

  {
    value: "application/vnd.google-earth.kmz+xml",
    label: "KML (compressed)",
  },
  {
    value: "application/vnd.google-earth.kml+xml&mode=networklink",
    label: "KML (network link)",
  },
  {
    value: "application/vnd.google-earth.kml",
    label: "KML (plain)",
  },
  {
    value: "text/html; subtype=openlayers",
    label: "OpenLayers",
  },
  {
    value: "application/openlayers2",
    label: "OpenLayers 2",
  },
  {
    value: "application/openlayers3",
    label: "OpenLayers 3",
  },
  {
    value: "application/pdf",
    label: "PDF",
  },
  {
    value: "image/png",
    label: "PNG",
  },
  {
    value: "image/png; mode=8bit",
    label: "PNG 8bit",
  },
  {
    value: "image/svg+xml",
    label: "SVG",
  },
  {
    value: "image/tiff",
    label: "Tiff",
  },
  {
    value: "image/tiff8",
    label: "Tiff 8-bits",
  },
  {
    value: "application/json;type=utfgrid",
    label: "UTFGrid",
  },
];
